module.exports = __webpack_public_path__ + "static/MAZIUSREVIEW20.09-Extraitalic-56e8cd1be1178b3fe1fd02e4f97406f0.woff";